import axios from "axios"

const api = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE}/api`,
  withCredentials: true,
})

api.interceptors.request.use(
  async (config) => {
    if (config.method === "post" || config.method === "put") {
      try {
        await axios.get(
          `${process.env.REACT_APP_API_BASE}/sanctum/csrf-cookie`,
          { withCredentials: true }
        )
        return config
      } catch (e) {
        throw new Error("Something went wrong in sanncturm csrf cookie!")
      }
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 403) {
      window.location.href = `${process.env.REACT_APP_SEPEHRINO_LANDING}/login-sign-up`;
    }
    return Promise.reject(error);
  }
);

export default api
